import LyfeTooltip from "../LyfeTooltip/LyfeTooltip";
import { Typography, makeStyles, TypographyProps } from "@material-ui/core";
import React, { useRef, useEffect, useState } from "react";

interface IEllipsisTypography {
	text: string;
	styles?: React.CSSProperties;
	truncate?: boolean;
}

const EllipsisTypography = ({ text, styles, truncate = false, ...other }: TypographyProps & IEllipsisTypography) => {
	const classes = useStyles();
	const textRef = useRef<HTMLDivElement>(null);
	const [showTooltip, setShowTooltip] = useState(false);
	const hasLongWord = text.split(/\s+/).some((word) => word.length > 25);
	const className = truncate ? (hasLongWord ? classes.ellipsisOverflow : classes.normalWrap) : classes.ellipsisOverflow;

	useEffect(() => {
		const element = textRef.current;
		if (element) {
			setShowTooltip(element.offsetWidth < element.scrollWidth);
		}
	}, [text]);

	return (
		<LyfeTooltip title={showTooltip ? text : ""}>
			<Typography {...other} style={{ ...styles }} className={className} ref={textRef}>
				{text}
			</Typography>
		</LyfeTooltip>
	);
};

export default EllipsisTypography;

const useStyles = makeStyles(() => ({
	ellipsisOverflow: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	normalWrap: {
		display: "inline-block",
		whiteSpace: "normal",
		wordBreak: "normal",
	},
}));
